import { render, staticRenderFns } from "./repair_delivery_detail_dialog.vue?vue&type=template&id=179b8c4e&scoped=true"
import script from "./repair_delivery_detail_dialog.vue?vue&type=script&lang=js"
export * from "./repair_delivery_detail_dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179b8c4e",
  null
  
)

export default component.exports